import c0 from './ajax_success_controller';
import c1 from './auto_submit_controller';
import c2 from './buttons/event_controller';
import c3 from './checkboxes/attribute_toggle_controller';
import c4 from './checkboxes/mirror_field_switch_controller';
import c5 from './checkboxes/show_when_checked_controller';
import c6 from './dispatch_from_store_controller';
import c7 from './domain_restrictions_controller';
import c8 from './forms/ajax_controller';
import c9 from './forms/change_request_controller';
import c10 from './forms/checkbox_input_toggle_controller';
import c11 from './forms/collapsible_controller';
import c12 from './forms/confirmation_controller';
import c13 from './forms/dropzone_controller';
import c14 from './forms/event_controller';
import c15 from './forms/require_input_controller';
import c16 from './forms/resettable_controller';
import c17 from './forms/signing_fields_controller';
import c18 from './forms/stored_fields_controller';
import c19 from './forms/untouchable_controller';
import c20 from './interval_reload_controller';
import c21 from './load_controller';
import c22 from './overlay_controller';
import c23 from './populate_mnemonic_controller';
import c24 from './scroll_to_view_controller';
import c25 from './selects/show_when_value_controller';
import c26 from './selects/url_switch_controller';
import c27 from './sortable_list_controller';
import c28 from './toggle_elements_controller';
import c29 from './untouchable_from_store_controller';
import c30 from './views/checkbox_collection_controller';
import c31 from './views/cloneable_element_controller';
import c32 from './views/concealed_text_controller';
import c33 from './views/copy_button_controller';
import c34 from './views/counter_controller';
import c35 from './views/custom_select_controller';
import c36 from './views/date_and_timepicker_field_controller';
import c37 from './views/datepicker_field_controller';
import c38 from './views/destroy_element_controller';
import c39 from './views/download_button_controller';
import c40 from './views/dropdown_controller';
import c41 from './views/editable_field_controller';
import c42 from './views/entity_share_link_form_controller';
import c43 from './views/flash_message_controller';
import c44 from './views/formatted_textarea_controller';
import c45 from './views/group_options_controller';
import c46 from './views/input_width_controller';
import c47 from './views/mirror_field_controller';
import c48 from './views/multi_checkbox_collection_controller';
import c49 from './views/multi_select_controller';
import c50 from './views/multiselect_search_controller';
import c51 from './views/notifications_controller';
import c52 from './views/pager_controller';
import c53 from './views/pdf_frame_controller';
import c54 from './views/preventable_controller';
import c55 from './views/reflected_count_banner_controller';
import c56 from './views/reflected_field_controller';
import c57 from './views/signatory_attachment_type_form_controller';
import c58 from './views/signatory_core_field_form_controller';
import c59 from './views/signatory_field_form_controller';
import c60 from './views/store_controller';
import c61 from './views/syncable_field_controller';
import c62 from './views/tab_aware_link_controller';
import c63 from './views/tabs_controller';
import c64 from './views/timepicker_field_controller';
import c65 from './views/tooltip_controller';
export const definitions = [
	{identifier: 'ajax-success', controllerConstructor: c0},
	{identifier: 'auto-submit', controllerConstructor: c1},
	{identifier: 'buttons--event', controllerConstructor: c2},
	{identifier: 'checkboxes--attribute-toggle', controllerConstructor: c3},
	{identifier: 'checkboxes--mirror-field-switch', controllerConstructor: c4},
	{identifier: 'checkboxes--show-when-checked', controllerConstructor: c5},
	{identifier: 'dispatch-from-store', controllerConstructor: c6},
	{identifier: 'domain-restrictions', controllerConstructor: c7},
	{identifier: 'forms--ajax', controllerConstructor: c8},
	{identifier: 'forms--change-request', controllerConstructor: c9},
	{identifier: 'forms--checkbox-input-toggle', controllerConstructor: c10},
	{identifier: 'forms--collapsible', controllerConstructor: c11},
	{identifier: 'forms--confirmation', controllerConstructor: c12},
	{identifier: 'forms--dropzone', controllerConstructor: c13},
	{identifier: 'forms--event', controllerConstructor: c14},
	{identifier: 'forms--require-input', controllerConstructor: c15},
	{identifier: 'forms--resettable', controllerConstructor: c16},
	{identifier: 'forms--signing-fields', controllerConstructor: c17},
	{identifier: 'forms--stored-fields', controllerConstructor: c18},
	{identifier: 'forms--untouchable', controllerConstructor: c19},
	{identifier: 'interval-reload', controllerConstructor: c20},
	{identifier: 'load', controllerConstructor: c21},
	{identifier: 'overlay', controllerConstructor: c22},
	{identifier: 'populate-mnemonic', controllerConstructor: c23},
	{identifier: 'scroll-to-view', controllerConstructor: c24},
	{identifier: 'selects--show-when-value', controllerConstructor: c25},
	{identifier: 'selects--url-switch', controllerConstructor: c26},
	{identifier: 'sortable-list', controllerConstructor: c27},
	{identifier: 'toggle-elements', controllerConstructor: c28},
	{identifier: 'untouchable-from-store', controllerConstructor: c29},
	{identifier: 'views--checkbox-collection', controllerConstructor: c30},
	{identifier: 'views--cloneable-element', controllerConstructor: c31},
	{identifier: 'views--concealed-text', controllerConstructor: c32},
	{identifier: 'views--copy-button', controllerConstructor: c33},
	{identifier: 'views--counter', controllerConstructor: c34},
	{identifier: 'views--custom-select', controllerConstructor: c35},
	{identifier: 'views--date-and-timepicker-field', controllerConstructor: c36},
	{identifier: 'views--datepicker-field', controllerConstructor: c37},
	{identifier: 'views--destroy-element', controllerConstructor: c38},
	{identifier: 'views--download-button', controllerConstructor: c39},
	{identifier: 'views--dropdown', controllerConstructor: c40},
	{identifier: 'views--editable-field', controllerConstructor: c41},
	{identifier: 'views--entity-share-link-form', controllerConstructor: c42},
	{identifier: 'views--flash-message', controllerConstructor: c43},
	{identifier: 'views--formatted-textarea', controllerConstructor: c44},
	{identifier: 'views--group-options', controllerConstructor: c45},
	{identifier: 'views--input-width', controllerConstructor: c46},
	{identifier: 'views--mirror-field', controllerConstructor: c47},
	{identifier: 'views--multi-checkbox-collection', controllerConstructor: c48},
	{identifier: 'views--multi-select', controllerConstructor: c49},
	{identifier: 'views--multiselect-search', controllerConstructor: c50},
	{identifier: 'views--notifications', controllerConstructor: c51},
	{identifier: 'views--pager', controllerConstructor: c52},
	{identifier: 'views--pdf-frame', controllerConstructor: c53},
	{identifier: 'views--preventable', controllerConstructor: c54},
	{identifier: 'views--reflected-count-banner', controllerConstructor: c55},
	{identifier: 'views--reflected-field', controllerConstructor: c56},
	{identifier: 'views--signatory-attachment-type-form', controllerConstructor: c57},
	{identifier: 'views--signatory-core-field-form', controllerConstructor: c58},
	{identifier: 'views--signatory-field-form', controllerConstructor: c59},
	{identifier: 'views--store', controllerConstructor: c60},
	{identifier: 'views--syncable-field', controllerConstructor: c61},
	{identifier: 'views--tab-aware-link', controllerConstructor: c62},
	{identifier: 'views--tabs', controllerConstructor: c63},
	{identifier: 'views--timepicker-field', controllerConstructor: c64},
	{identifier: 'views--tooltip', controllerConstructor: c65},
];
